import { render, staticRenderFns } from "./DeviceTemplateList.vue?vue&type=template&id=57f6c4dc&scoped=true&"
import script from "./DeviceTemplateList.vue?vue&type=script&lang=ts&"
export * from "./DeviceTemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceTemplateList.vue?vue&type=style&index=0&id=57f6c4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6c4dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VHover,VIcon,VRow,VSnackbar,VSpacer})
